import React from "react";
import ProfileCard from "../ProfileCard";

function Footer() {
  return (
    <>
      <div
        className="bg-center bg-fixed bg-no-repeat bg-cover absolute w-full"
        style={{
          backgroundImage: `url("assets/images/bg-img.jpg")`,
        }}
      >
        <section className="w-100 px-6 py-12 max-w-screen-2xl m-auto">
          <div className="flex justify-center lg:justify-between">
            <div className="flex flex-col gap-4 items-center lg:items-start">
              <div className="w-40 h-40 p-3 bg-[#fff]/[.2] rounded-lg cursor-pointer">
                <img src="assets/images/user/user-img.jpg" alt="" />
              </div>
              <span className="bg-[#fff]/[.2] px-4 py-0.5 inline-block rounded-full font-semibold text-[#fff] text-lg">
                001
              </span>

              <a
                href="#"
                className="font-semibold text-[#fff] text-5xl uppercase m-0 block"
              >
                Mochi
              </a>

              <h5 className="capitalize text-[#fff]/[.6] font-semibold text-lg">
                50 Artwork
              </h5>

              <div className="bg-[#fff]/[.2] hover:bg-[#fff] text-[#fff]  hover:text-[#000] px-4 py-3 my-4 shadow-lg hover:shadow-xl inline-flex justify-between cursor-pointer gap-3 items-center rounded-full uppercase font-semibold hover:-translate-y-1 duration-300 ease-out ">
                <div className="w-8 h-8 rounded-full truncate">
                  <img src="assets/images/user/user.jpg" alt="User Image" />
                </div>
                <a>@stillz</a>
              </div>
            </div>
            <div className="hidden lg:grid grid-col-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
              <ProfileCard />
              <ProfileCard />
              <ProfileCard />
            </div>
          </div>

          <footer className="flex justify-around  lg:justify-between lg:items-center mt-10 text-sm">
            <ul className="flex flex-col lg:flex-row items-start gap-x-5 font-semibold text-[#fff]/[.8] list-none  leading-5">
              <li>
                <a href="#" className="inline-block">
                  <svg
                    className="h-6 fill-[#fff]"
                    viewBox="0 0 98 33"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="current-color"
                  >
                    <path
                      clip-rule="evenodd"
                      d="M64.894 16.456c0 9.088-7.368 16.456-16.457 16.456s-16.455-7.368-16.455-16.456S39.349 0 48.438 0s16.455 7.368 16.455 16.456zM16.902 1.567a.784.784 0 0 1 1.358 0L35.056 30.66a.784.784 0 0 1-.679 1.176H.785a.784.784 0 0 1-.679-1.176zM68.614.98c-.865 0-1.567.702-1.567 1.568v27.818c0 .866.702 1.567 1.567 1.567h27.819c.865 0 1.567-.701 1.567-1.567V2.547c0-.866-.702-1.568-1.567-1.568z"
                    ></path>
                  </svg>
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[#fff]">
                  Instagram
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[#fff]">
                  Twitter
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[#fff]">
                  Blog
                </a>
              </li>
            </ul>

            <ul className="flex flex-col lg:flex-row items-start gap-x-5 font-semibold leading-5 list-none text-[#fff]/[.8]">
              <li>
                <a href="#" className="hover:text-[#fff]">
                  About
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[#fff]">
                  Press
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[#fff]">
                  Careers
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[#fff]">
                  Community Guidelines
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[#fff]">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[#fff]">
                  Privacy
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[#fff]">
                  Help
                </a>
              </li>
            </ul>
          </footer>
        </section>
      </div>
    </>
  );
}

export default Footer;
